{
  "BCH": {
    "code": "BCH",
    "precision": 8,
    "units": {
      "BCH": {
        "code": "BCH",
        "symbol": "BCH",
        "name": "Bitcoin Cash",
        "displayPrecision": 8,
        "inputPrecision": 8,
        "shift": 0
      }
    }
  },
  "DASH": {
    "code": "DASH",
    "precision": 8,
    "units": {
      "DASH": {
        "code": "DASH",
        "symbol": "DASH",
        "name": "Dash",
        "displayPrecision": 8,
        "inputPrecision": 8,
        "shift": 0
      }
    }
  },
  "DOT": {
    "code": "DOT",
    "precision": 10,
    "units": {
      "DOT": {
        "code": "DOT",
        "symbol": "DOT",
        "name": "Polkadot",
        "displayPrecision": 10,
        "inputPrecision": 10,
        "shift": 0
      }
    }
  },
  "BYN": {
    "code": "BYN",
    "precision": 5,
    "units": {
      "BYN": {
        "code": "BYN",
        "symbol": "Br",
        "name": "Belarusian ruble",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "kapyeyka",
        "symbol": "",
        "name": "Belarusian kapyeyka",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BTC": {
    "code": "BTC",
    "precision": 8,
    "units": {
      "BTC": {
        "code": "BTC",
        "symbol": "₿",
        "name": "Bitcoin",
        "displayPrecision": 8,
        "inputPrecision": 8,
        "shift": 0
      },
      "mBTC": {
        "code": "mBTC",
        "symbol": "m₿",
        "name": "Milli-bitcoin",
        "displayPrecision": 4,
        "inputPrecision": 5,
        "shift": 3
      },
      "uBTC": {
        "code": "uBTC",
        "symbol": "μ₿",
        "name": "Bits",
        "displayPrecision": 2,
        "inputPrecision": 2,
        "shift": 6
      },
      "sat": {
        "code": "sat",
        "symbol": "₿",
        "name": "Satoshi",
        "displayPrecision": 0,
        "inputPrecision": 0,
        "shift": 8
      }
    }
  },
  "ETH": {
    "code": "ETH",
    "precision": 8,
    "units": {
      "ETH": {
        "code": "ETH",
        "symbol": "ETH",
        "name": "Ether",
        "displayPrecision": 8,
        "inputPrecision": 8,
        "shift": 0
      },
      "mETH": {
        "code": "mETH",
        "symbol": "mETH",
        "name": "Milliether",
        "displayPrecision": 4,
        "inputPrecision": 5,
        "shift": 3
      },
      "uETH": {
        "code": "uETH",
        "symbol": "μETH",
        "name": "Microether",
        "displayPrecision": 2,
        "inputPrecision": 2,
        "shift": 6
      },
      "Gwei": {
        "code": "Gwei",
        "symbol": "Gwei",
        "name": "Gwei",
        "displayPrecision": 0,
        "inputPrecision": 0,
        "shift": 8
      }
    }
  },
  "SOC": {
    "code": "SOC",
    "precision": 8,
    "units": {
      "SOC": {
        "code": "SOC",
        "symbol": "SOC",
        "name": "All Sports",
        "displayPrecision": 8,
        "inputPrecision": 8,
        "shift": 0
      }
    }
  },
  "LTC": {
    "code": "LTC",
    "precision": 8,
    "units": {
      "LTC": {
        "code": "LTC",
        "symbol": "Ł",
        "name": "Litecoin",
        "displayPrecision": 8,
        "inputPrecision": 8,
        "shift": 0
      },
      "mLTC": {
        "code": "mLTC",
        "symbol": "mŁ",
        "name": "milli-Litecoin",
        "displayPrecision": 4,
        "inputPrecision": 5,
        "shift": 3
      },
      "uLTC": {
        "code": "uLTC",
        "symbol": "μŁ",
        "name": "micro-Litecoin",
        "displayPrecision": 2,
        "inputPrecision": 2,
        "shift": 6
      },
      "lit": {
        "code": "lit",
        "symbol": "",
        "name": "Litoshi",
        "displayPrecision": 0,
        "inputPrecision": 0,
        "shift": 8
      }
    }
  },
  "TRX": {
    "code": "TRX",
    "precision": 8,
    "units": {
      "TRX": {
        "code": "TRX",
        "symbol": "TRX",
        "name": "Tron",
        "displayPrecision": 8,
        "inputPrecision": 6,
        "shift": 0
      },
      "mTRX": {
        "code": "mTRX",
        "symbol": "mTRX",
        "name": "milli-Tron",
        "displayPrecision": 4,
        "inputPrecision": 3,
        "shift": 3
      },
      "uTRX": {
        "code": "uTRX",
        "symbol": "μTRX",
        "name": "micro-Tron",
        "displayPrecision": 2,
        "inputPrecision": 0,
        "shift": 6
      }
    }
  },
  "XRP": {
    "code": "XRP",
    "precision": 6,
    "units": {
      "XRP": {
        "code": "XRP",
        "symbol": "XRP",
        "name": "Ripple",
        "displayPrecision": 6,
        "inputPrecision": 6,
        "shift": 0
      },
      "mXRP": {
        "code": "mXRP",
        "symbol": "mXRP",
        "name": "milli-Ripple",
        "displayPrecision": 3,
        "inputPrecision": 3,
        "shift": 3
      },
      "uXRP": {
        "code": "uXRP",
        "symbol": "μXRP",
        "name": "micro-Ripple",
        "displayPrecision": 0,
        "inputPrecision": 0,
        "shift": 6
      },
      "drop": {
        "code": "drop",
        "symbol": "drop",
        "name": "drop",
        "displayPrecision": 0,
        "inputPrecision": 0,
        "shift": 6
      }
    }
  },
  "ADA": {
    "code": "ADA",
    "precision": 6,
    "units": {
      "ADA": {
        "code": "ADA",
        "symbol": "ADA",
        "name": "Cardano",
        "displayPrecision": 6,
        "inputPrecision": 6,
        "shift": 0
      },
      "mADA": {
        "code": "mADA",
        "symbol": "mADA",
        "name": "milli-Cardano",
        "displayPrecision": 3,
        "inputPrecision": 3,
        "shift": 3
      },
      "uADA": {
        "code": "uADA",
        "symbol": "μADA",
        "name": "micro-Cardano",
        "displayPrecision": 0,
        "inputPrecision": 0,
        "shift": 6
      },
      "drop": {
        "code": "drop",
        "symbol": "drop",
        "name": "drop",
        "displayPrecision": 0,
        "inputPrecision": 0,
        "shift": 6
      }
    }
  },
  "DOGE": {
    "code": "DOGE",
    "precision": 6,
    "units": {
      "DOGE": {
        "code": "DOGE",
        "symbol": "Ɖ",
        "name": "Dogecoin",
        "displayPrecision": 6,
        "inputPrecision": 6,
        "shift": 0
      },
      "mDOGE": {
        "code": "mDOGE",
        "symbol": "mƉ",
        "name": "milli-Doge",
        "displayPrecision": 3,
        "inputPrecision": 3,
        "shift": 3
      },
      "μDOGE ": {
        "code": "μDOGE ",
        "symbol": "μƉ",
        "name": "micro-Doge",
        "displayPrecision": 0,
        "inputPrecision": 0,
        "shift": 6
      }
    }
  },
  "EOS": {
    "code": "EOS",
    "precision": 6,
    "units": {
      "EOS": {
        "code": "EOS",
        "symbol": "EOS",
        "name": "EOS",
        "shift": 0,
        "displayPrecision": 6,
        "inputPrecision": 6
      }
    }
  },
  "MATIC": {
    "code": "MATIC",
    "precision": 8,
    "units": {
      "MATIC": {
        "code": "MATIC",
        "symbol": "MATIC",
        "name": "MATIC",
        "displayPrecision": 8,
        "inputPrecision": 8,
        "shift": 0
      }
    }
  },
  "POL": {
    "code": "POL",
    "precision": 8,
    "units": {
      "POL": {
        "code": "POL",
        "symbol": "POL",
        "name": "Polygon",
        "displayPrecision": 8,
        "inputPrecision": 8,
        "shift": 0
      }
    }
  },
  "TON": {
    "code": "TON",
    "precision": 9,
    "units": {
      "TON": {
        "code": "TON",
        "symbol": "TON",
        "name": "TON",
        "displayPrecision": 9,
        "inputPrecision": 9,
        "shift": 0
      },
      "mTON": {
        "code": "mTON",
        "symbol": "mTON",
        "name": "milli-Toncoin",
        "shift": 3,
        "displayPrecision": 6,
        "inputPrecision": 6
      }
    }
  },
  "BNB": {
    "code": "BNB",
    "precision": 8,
    "units": {
      "BNB": {
        "code": "BNB",
        "symbol": "BNB",
        "name": "BNB",
        "displayPrecision": 8,
        "inputPrecision": 8,
        "shift": 0
      },
      "mBNB": {
        "code": "mBNB",
        "symbol": "mBNB",
        "name": "Millibnb",
        "displayPrecision": 4,
        "inputPrecision": 5,
        "shift": 3
      },
      "uBNB": {
        "code": "uBNB",
        "symbol": "μBNB",
        "name": "Microbnb",
        "displayPrecision": 2,
        "inputPrecision": 2,
        "shift": 6
      },
      "Gwei": {
        "code": "Jager",
        "symbol": "Jager",
        "name": "Jager",
        "displayPrecision": 0,
        "inputPrecision": 0,
        "shift": 8
      }
    }
  },
  "AED": {
    "code": "AED",
    "precision": 5,
    "units": {
      "AED": {
        "code": "AED",
        "symbol": ".د.ب",
        "name": "Emirati dirham",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "fils",
        "symbol": "فلس",
        "name": "Emirati fils",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "AFN": {
    "code": "AFN",
    "precision": 5,
    "units": {
      "AFN": {
        "code": "AFN",
        "symbol": "؋",
        "name": "Afghan afghani",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Pul",
        "symbol": "",
        "name": "Afghan Pul",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "ALL": {
    "code": "ALL",
    "precision": 5,
    "units": {
      "ALL": {
        "code": "ALL",
        "symbol": "lek",
        "name": "Albanian lek",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Qindarkë",
        "symbol": "",
        "name": "Albanian Qindarkë",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "AMD": {
    "code": "AMD",
    "precision": 5,
    "units": {
      "AMD": {
        "code": "AMD",
        "symbol": "",
        "name": "Armenian dram",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "luma",
        "symbol": "",
        "name": "Armenian luma",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "ANG": {
    "code": "ANG",
    "precision": 5,
    "units": {
      "ANG": {
        "code": "ANG",
        "symbol": "ƒ",
        "name": "Dutch guilder",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Dutch cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "AOA": {
    "code": "AOA",
    "precision": 5,
    "units": {
      "AOA": {
        "code": "AOA",
        "symbol": "Kz",
        "name": "Angolan Kwanza",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cêntimos",
        "symbol": "",
        "name": "Angolan cêntimos",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "ARS": {
    "code": "ARS",
    "precision": 5,
    "units": {
      "ARS": {
        "code": "ARS",
        "symbol": "$",
        "name": "Argentine peso",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "",
        "name": "Argentine centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "AUD": {
    "code": "AUD",
    "precision": 5,
    "units": {
      "AUD": {
        "code": "AUD",
        "symbol": "$",
        "name": "Australian dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "c",
        "name": "Australian cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "AWG": {
    "code": "AWG",
    "precision": 5,
    "units": {
      "AWG": {
        "code": "AWG",
        "symbol": "ƒ",
        "name": "Arubin florin",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Arubin cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "AZN": {
    "code": "AZN",
    "precision": 5,
    "units": {
      "AZN": {
        "code": "AZN",
        "symbol": "ман",
        "name": "Azerbaijani manat",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Qepik",
        "symbol": "qr",
        "name": "Azerbaijani Qepik",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BAM": {
    "code": "BAM",
    "precision": 5,
    "units": {
      "BAM": {
        "code": "BAM",
        "symbol": "KM",
        "name": "Bosnian Convertible covertible marks",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "fening",
        "symbol": "",
        "name": "Bosnian Convertible fening",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BBD": {
    "code": "BBD",
    "precision": 5,
    "units": {
      "BBD": {
        "code": "BBD",
        "symbol": "$",
        "name": "Barbadian dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Barbadian cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BDT": {
    "code": "BDT",
    "precision": 5,
    "units": {
      "BDT": {
        "code": "BDT",
        "symbol": "Tk",
        "name": "Bangladeshi Taka",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Poisha",
        "symbol": "",
        "name": "Bangladeshi Poisha",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BGN": {
    "code": "BGN",
    "precision": 5,
    "units": {
      "BGN": {
        "code": "BGN",
        "symbol": "лв",
        "name": "Bulgarian lev",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "stotinki",
        "symbol": "стотинки",
        "name": "Bulgarian stotinki",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BHD": {
    "code": "BHD",
    "precision": 5,
    "units": {
      "BHD": {
        "code": "BHD",
        "symbol": ".د.ب or BD",
        "name": "Bahraini dinar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "fils",
        "symbol": "",
        "name": "Bahraini fils",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BIF": {
    "code": "BIF",
    "precision": 5,
    "units": {
      "BIF": {
        "code": "BIF",
        "symbol": "",
        "name": "Burundian franc",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centime",
        "symbol": "",
        "name": "Burundian centime",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BMD": {
    "code": "BMD",
    "precision": 5,
    "units": {
      "BMD": {
        "code": "BMD",
        "symbol": "$",
        "name": "Bermudian dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "¢",
        "name": "Bermudian cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BND": {
    "code": "BND",
    "precision": 5,
    "units": {
      "BND": {
        "code": "BND",
        "symbol": "$",
        "name": "Bruneian dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Bruneian cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BOB": {
    "code": "BOB",
    "precision": 5,
    "units": {
      "BOB": {
        "code": "BOB",
        "symbol": "$b",
        "name": "Bolivian boliviano",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "",
        "name": "Bolivian centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BRL": {
    "code": "BRL",
    "precision": 5,
    "units": {
      "BRL": {
        "code": "BRL",
        "symbol": "R$",
        "name": "Brazilian real",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "",
        "name": "Brazilian centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BSD": {
    "code": "BSD",
    "precision": 5,
    "units": {
      "BSD": {
        "code": "BSD",
        "symbol": "B$",
        "name": "Bahamian dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Bahamian cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BTN": {
    "code": "BTN",
    "precision": 5,
    "units": {
      "BTN": {
        "code": "BTN",
        "symbol": "Nu.",
        "name": "Bhutanese Ngultrum",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Chhertum",
        "symbol": "Ch.",
        "name": "Bhutanese Chhertum",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BWP": {
    "code": "BWP",
    "precision": 5,
    "units": {
      "BWP": {
        "code": "BWP",
        "symbol": "P",
        "name": "Botswana Pula",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Thebe",
        "symbol": "t",
        "name": "Botswana Thebe",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BYR": {
    "code": "BYR",
    "precision": 5,
    "units": {
      "BYR": {
        "code": "BYR",
        "symbol": "р",
        "name": "Belarusian ruble",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "kapeyka",
        "symbol": "к",
        "name": "Belarusian kapeyka",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BZD": {
    "code": "BZD",
    "precision": 5,
    "units": {
      "BZD": {
        "code": "BZD",
        "symbol": "BZ$",
        "name": "Belize dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Belize cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "CAD": {
    "code": "CAD",
    "precision": 5,
    "units": {
      "CAD": {
        "code": "CAD",
        "symbol": "$",
        "name": "Canadian dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "¢",
        "name": "Canadian cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "CHF": {
    "code": "CHF",
    "precision": 5,
    "units": {
      "CHF": {
        "code": "CHF",
        "symbol": "CHF",
        "name": "Swiss franc",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "rappen",
        "symbol": "Rp.",
        "name": "Swiss rappen",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "CLP": {
    "code": "CLP",
    "precision": 5,
    "units": {
      "CLP": {
        "code": "CLP",
        "symbol": "$",
        "name": "Chilean peso",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "",
        "name": "Chilean centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "CNY": {
    "code": "CNY",
    "precision": 5,
    "units": {
      "CNY": {
        "code": "CNY",
        "symbol": "¥",
        "name": "Yuan or chinese yuan",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "jiǎo",
        "symbol": "角",
        "name": "Yuan or chinese jiǎo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "COP": {
    "code": "COP",
    "precision": 5,
    "units": {
      "COP": {
        "code": "COP",
        "symbol": "$",
        "name": "Colombian peso",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "",
        "name": "Colombian centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "CRC": {
    "code": "CRC",
    "precision": 5,
    "units": {
      "CRC": {
        "code": "CRC",
        "symbol": "₡",
        "name": "Costa Rican colón",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "céntimo",
        "symbol": "₡",
        "name": "Costa Rican céntimo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "CUC": {
    "code": "CUC",
    "precision": 5,
    "units": {
      "CUC": {
        "code": "CUC",
        "symbol": "$",
        "name": "Cuban convertible peso",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "¢",
        "name": "Cuban convertible centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "CUP": {
    "code": "CUP",
    "precision": 5,
    "units": {
      "CUP": {
        "code": "CUP",
        "symbol": "₱",
        "name": "Cuban peso",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "¢",
        "name": "Cuban centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "CVE": {
    "code": "CVE",
    "precision": 5,
    "units": {
      "CVE": {
        "code": "CVE",
        "symbol": "$",
        "name": "Cape Verdean escudo",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "",
        "name": "Cape Verdean centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "CZK": {
    "code": "CZK",
    "precision": 5,
    "units": {
      "CZK": {
        "code": "CZK",
        "symbol": "Kč",
        "name": "Czech koruna",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "haléř",
        "symbol": "h",
        "name": "Czech haléř",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "DJF": {
    "code": "DJF",
    "precision": 5,
    "units": {
      "DJF": {
        "code": "DJF",
        "symbol": "fdj",
        "name": "Djiboutian franc",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centime",
        "symbol": "",
        "name": "Djiboutian centime",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "DKK": {
    "code": "DKK",
    "precision": 5,
    "units": {
      "DKK": {
        "code": "DKK",
        "symbol": "kr",
        "name": "Danish kroner",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "kroner",
        "symbol": "øre",
        "name": "Danish kroner",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "DOP": {
    "code": "DOP",
    "precision": 5,
    "units": {
      "DOP": {
        "code": "DOP",
        "symbol": "$",
        "name": "Dominican peso",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "",
        "name": "Dominican centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "DZD": {
    "code": "DZD",
    "precision": 5,
    "units": {
      "DZD": {
        "code": "DZD",
        "symbol": "جد",
        "name": "Algerian dinar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Santeem",
        "symbol": "",
        "name": "Algerian Santeem",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "EGP": {
    "code": "EGP",
    "precision": 5,
    "units": {
      "EGP": {
        "code": "EGP",
        "symbol": "£ ",
        "name": "Egyptian pound",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "piastre",
        "symbol": "Pt",
        "name": "Egyptian piastre",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "ERN": {
    "code": "ERN",
    "precision": 5,
    "units": {
      "ERN": {
        "code": "ERN",
        "symbol": "ናቕፋ",
        "name": "Eritrean nafka",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Eritrean cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "ETB": {
    "code": "ETB",
    "precision": 5,
    "units": {
      "ETB": {
        "code": "ETB",
        "symbol": "Br",
        "name": "Ethiopian Birr",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "santim",
        "symbol": "",
        "name": "Ethiopian santim",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "EUR": {
    "code": "EUR",
    "precision": 5,
    "units": {
      "EUR": {
        "code": "EUR",
        "symbol": "€",
        "name": "Euro",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "c",
        "name": " cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "EURC": {
    "code": "EURC",
    "precision": 5,
    "units": {
      "EURC": {
        "code": "EURC",
        "symbol": "EURC",
        "name": "EURC",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "EURC cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "FJD": {
    "code": "FJD",
    "precision": 5,
    "units": {
      "FJD": {
        "code": "FJD",
        "symbol": "$",
        "name": "Fijian dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "¢",
        "name": "Fijian cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "FKP": {
    "code": "FKP",
    "precision": 5,
    "units": {
      "FKP": {
        "code": "FKP",
        "symbol": "£",
        "name": "Falkland Island pound",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "penny",
        "symbol": "p",
        "name": "Falkland Island penny",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "GBP": {
    "code": "GBP",
    "precision": 5,
    "units": {
      "GBP": {
        "code": "GBP",
        "symbol": "£",
        "name": "British pound",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "penny",
        "symbol": "p",
        "name": "British penny",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "GEL": {
    "code": "GEL",
    "precision": 5,
    "units": {
      "GEL": {
        "code": "GEL",
        "symbol": "ლ",
        "name": "Georgian lari",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "tetri",
        "symbol": "",
        "name": "Georgian tetri",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "GHS": {
    "code": "GHS",
    "precision": 5,
    "units": {
      "GHS": {
        "code": "GHS",
        "symbol": "GH¢",
        "name": "Ghanaian Cedi",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Pesewa",
        "symbol": "Gp",
        "name": "Ghanaian Pesewa",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "GIP": {
    "code": "GIP",
    "precision": 5,
    "units": {
      "GIP": {
        "code": "GIP",
        "symbol": "£",
        "name": "Gibraltar pound",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "penny",
        "symbol": "p",
        "name": "Gibraltar penny",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "GMD": {
    "code": "GMD",
    "precision": 5,
    "units": {
      "GMD": {
        "code": "GMD",
        "symbol": "",
        "name": "Gambian dalasi",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "butut",
        "symbol": "",
        "name": "Gambian butut",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "GNF": {
    "code": "GNF",
    "precision": 5,
    "units": {
      "GNF": {
        "code": "GNF",
        "symbol": "",
        "name": "Guinean franc",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centime",
        "symbol": "",
        "name": "Guinean centime",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "GTQ": {
    "code": "GTQ",
    "precision": 5,
    "units": {
      "GTQ": {
        "code": "GTQ",
        "symbol": "Q",
        "name": "Guatemalan quetzales",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "",
        "name": "Guatemalan centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "GYD": {
    "code": "GYD",
    "precision": 5,
    "units": {
      "GYD": {
        "code": "GYD",
        "symbol": "$",
        "name": "Guyanese dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Guyanese cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "HKD": {
    "code": "HKD",
    "precision": 5,
    "units": {
      "HKD": {
        "code": "HKD",
        "symbol": "HK$",
        "name": "Hong Kong dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Hong Kong cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "HNL": {
    "code": "HNL",
    "precision": 5,
    "units": {
      "HNL": {
        "code": "HNL",
        "symbol": "L",
        "name": "Honduran lempira",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "",
        "name": "Honduran centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "HRK": {
    "code": "HRK",
    "precision": 5,
    "units": {
      "HRK": {
        "code": "HRK",
        "symbol": "kn",
        "name": "Croatian kuna",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "lipa",
        "symbol": "lp",
        "name": "Croatian lipa",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "HTG": {
    "code": "HTG",
    "precision": 5,
    "units": {
      "HTG": {
        "code": "HTG",
        "symbol": "G",
        "name": "Haitian gourde",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centime",
        "symbol": "",
        "name": "Haitian centime",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "HUF": {
    "code": "HUF",
    "precision": 5,
    "units": {
      "HUF": {
        "code": "HUF",
        "symbol": "Ft",
        "name": "Hungarian forint",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "fillér",
        "symbol": "",
        "name": "Hungarian fillér",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "IDR": {
    "code": "IDR",
    "precision": 5,
    "units": {
      "IDR": {
        "code": "IDR",
        "symbol": "Rp",
        "name": "Indonesian Rupiah",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "kIDR": {
        "code": "kIDR",
        "symbol": "kRp",
        "name": "Indonesian kilo-rupiah",
        "shift": -3,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Sen",
        "symbol": "",
        "name": "Indonesian Sen",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "ILS": {
    "code": "ILS",
    "precision": 5,
    "units": {
      "ILS": {
        "code": "ILS",
        "symbol": "₪",
        "name": "Israeli Shekel",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Agorat",
        "symbol": "",
        "name": "Israeli Agorat",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "INR": {
    "code": "INR",
    "precision": 5,
    "units": {
      "INR": {
        "code": "INR",
        "symbol": "₹",
        "name": "Indian Rupee",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "paisa",
        "symbol": "p",
        "name": "Indian paisa",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      },
      "kINR": {
        "code": "kINR",
        "symbol": "k₹",
        "name": "Indian kilo-rupee",
        "shift": -3,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "IQD": {
    "code": "IQD",
    "precision": 5,
    "units": {
      "IQD": {
        "code": "IQD",
        "symbol": "ع.د",
        "name": "Iraqi dinar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "fils",
        "symbol": "",
        "name": "Iraqi fils",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "IRR": {
    "code": "IRR",
    "precision": 5,
    "units": {
      "IRR": {
        "code": "IRR",
        "symbol": "",
        "name": "Iranian rial",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "dinar",
        "symbol": "",
        "name": "Iranian dinar",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "ISK": {
    "code": "ISK",
    "precision": 5,
    "units": {
      "ISK": {
        "code": "ISK",
        "symbol": "kr",
        "name": "Icelandic krona",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "eyrir",
        "symbol": "",
        "name": "Icelandic eyrir",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "JMD": {
    "code": "JMD",
    "precision": 5,
    "units": {
      "JMD": {
        "code": "JMD",
        "symbol": "J$",
        "name": "Jamaican dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "c",
        "name": "Jamaican cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "JOD": {
    "code": "JOD",
    "precision": 5,
    "units": {
      "JOD": {
        "code": "JOD",
        "symbol": "",
        "name": "Jordanian Dinar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "qirsh ou piastre",
        "symbol": "",
        "name": "Jordanian qirsh ou piastre",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "JPY": {
    "code": "JPY",
    "precision": 5,
    "units": {
      "JPY": {
        "code": "JPY",
        "symbol": "¥",
        "name": "Japanese yen",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "sen",
        "symbol": "",
        "name": "Japanese sen",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "KES": {
    "code": "KES",
    "precision": 5,
    "units": {
      "KES": {
        "code": "KES",
        "symbol": "KSh",
        "name": "Kenyan Shilling",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "c",
        "name": "Kenyan cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "KGS": {
    "code": "KGS",
    "precision": 5,
    "units": {
      "KGS": {
        "code": "KGS",
        "symbol": "KGS",
        "name": "Kyrgyzstani som",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "tyiyn",
        "symbol": "",
        "name": "Kyrgyzstani tyiyn",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "KHR": {
    "code": "KHR",
    "precision": 5,
    "units": {
      "KHR": {
        "code": "KHR",
        "symbol": "៛",
        "name": "Cambodian riel",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "kak",
        "symbol": "",
        "name": "Cambodian kak",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "KMF": {
    "code": "KMF",
    "precision": 5,
    "units": {
      "KMF": {
        "code": "KMF",
        "symbol": "",
        "name": "Comoran franc",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centime",
        "symbol": "",
        "name": "Comoran centime",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "KPW": {
    "code": "KPW",
    "precision": 5,
    "units": {
      "KPW": {
        "code": "KPW",
        "symbol": "₩",
        "name": "North Korean won",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "chon",
        "symbol": "",
        "name": "North Korean chon",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "KRW": {
    "code": "KRW",
    "precision": 5,
    "units": {
      "KRW": {
        "code": "KRW",
        "symbol": "₩",
        "name": "South Korean won",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "jeon",
        "symbol": "",
        "name": "South Korean jeon",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "KWD": {
    "code": "KWD",
    "precision": 5,
    "units": {
      "KWD": {
        "code": "KWD",
        "symbol": "ك",
        "name": "Kuwaiti dinar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "fils",
        "symbol": "",
        "name": "Kuwaiti fils",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "KYD": {
    "code": "KYD",
    "precision": 5,
    "units": {
      "KYD": {
        "code": "KYD",
        "symbol": "$",
        "name": "Caymanian dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Caymanian cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "KZT": {
    "code": "KZT",
    "precision": 5,
    "units": {
      "KZT": {
        "code": "KZT",
        "symbol": "₸",
        "name": "Kazakhstani tenge",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "tïın",
        "symbol": "",
        "name": "Kazakhstani tïın",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "LAK": {
    "code": "LAK",
    "precision": 5,
    "units": {
      "LAK": {
        "code": "LAK",
        "symbol": "₭",
        "name": "Lao or Laotian Kip",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Att",
        "symbol": "",
        "name": "Lao or Laotian Att",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "LBP": {
    "code": "LBP",
    "precision": 5,
    "units": {
      "LBP": {
        "code": "LBP",
        "symbol": "ل.ل",
        "name": "Lebanese pound",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "piastre",
        "symbol": "",
        "name": "Lebanese piastre",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "LKR": {
    "code": "LKR",
    "precision": 5,
    "units": {
      "LKR": {
        "code": "LKR",
        "symbol": "Rs",
        "name": "Sri Lankan Rupee",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Sri Lankan cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "LRD": {
    "code": "LRD",
    "precision": 5,
    "units": {
      "LRD": {
        "code": "LRD",
        "symbol": "$",
        "name": "Liberian dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "¢",
        "name": "Liberian cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "LSL": {
    "code": "LSL",
    "precision": 5,
    "units": {
      "LSL": {
        "code": "LSL",
        "symbol": "L or M",
        "name": "Lesotho loti (maloti)",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "sente (lisente)",
        "symbol": "",
        "name": "Lesotho sente (lisente)",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "LTL": {
    "code": "LTL",
    "precision": 5,
    "units": {
      "LTL": {
        "code": "LTL",
        "symbol": "Lt",
        "name": "Lithuanian litas",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centas",
        "symbol": "ct",
        "name": "Lithuanian centas",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "LYD": {
    "code": "LYD",
    "precision": 5,
    "units": {
      "LYD": {
        "code": "LYD",
        "symbol": " د.ل",
        "name": "Libyan dinar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "dirham",
        "symbol": "",
        "name": "Libyan dirham",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MAD": {
    "code": "MAD",
    "precision": 5,
    "units": {
      "MAD": {
        "code": "MAD",
        "symbol": "م.د.",
        "name": "Moroccan dirham",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "santim",
        "symbol": "santimat",
        "name": "Moroccan santim",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MDL": {
    "code": "MDL",
    "precision": 5,
    "units": {
      "MDL": {
        "code": "MDL",
        "symbol": "L",
        "name": "Moldovan Leu",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Ban",
        "symbol": "",
        "name": "Moldovan Ban",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MGA": {
    "code": "MGA",
    "precision": 5,
    "units": {
      "MGA": {
        "code": "MGA",
        "symbol": "Ar",
        "name": "Malagasy Ariary",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Iraimbilanja",
        "symbol": "",
        "name": "Malagasy Iraimbilanja",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MKD": {
    "code": "MKD",
    "precision": 5,
    "units": {
      "MKD": {
        "code": "MKD",
        "symbol": "ден",
        "name": "Macedonian denar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "deni",
        "symbol": "",
        "name": "Macedonian deni",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MMK": {
    "code": "MMK",
    "precision": 5,
    "units": {
      "MMK": {
        "code": "MMK",
        "symbol": "K",
        "name": "Burmese Kyat",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Pya",
        "symbol": "",
        "name": "Burmese Pya",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MNT": {
    "code": "MNT",
    "precision": 5,
    "units": {
      "MNT": {
        "code": "MNT",
        "symbol": "₮",
        "name": "Mongolian Tughrik",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Möngö",
        "symbol": "",
        "name": "Mongolian Möngö",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MOP": {
    "code": "MOP",
    "precision": 5,
    "units": {
      "MOP": {
        "code": "MOP",
        "symbol": "MOP$",
        "name": "Macau pataca",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "ho",
        "symbol": "毫",
        "name": "Macau ho",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MRO": {
    "code": "MRO",
    "precision": 5,
    "units": {
      "MRO": {
        "code": "MRO",
        "symbol": "UM",
        "name": "Mauritanian Ouguiya",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "khoums",
        "symbol": "",
        "name": "Mauritanian khoums",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MUR": {
    "code": "MUR",
    "precision": 5,
    "units": {
      "MUR": {
        "code": "MUR",
        "symbol": "Rs",
        "name": "Mauritian rupee",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Mauritian cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MVR": {
    "code": "MVR",
    "precision": 5,
    "units": {
      "MVR": {
        "code": "MVR",
        "symbol": "rf",
        "name": "Maldivian Rufiyaa",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "laari",
        "symbol": "",
        "name": "Maldivian laari",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MWK": {
    "code": "MWK",
    "precision": 5,
    "units": {
      "MWK": {
        "code": "MWK",
        "symbol": "MK",
        "name": "Malawian Kwacha",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Tambala",
        "symbol": "",
        "name": "Malawian Tambala",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MXN": {
    "code": "MXN",
    "precision": 5,
    "units": {
      "MXN": {
        "code": "MXN",
        "symbol": "$",
        "name": "Mexico dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "¢",
        "name": "Mexico centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MYR": {
    "code": "MYR",
    "precision": 5,
    "units": {
      "MYR": {
        "code": "MYR",
        "symbol": "RM",
        "name": "Malaysian Ringgit",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Sen",
        "symbol": "Sen",
        "name": "Malaysian Sen",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "MZN": {
    "code": "MZN",
    "precision": 5,
    "units": {
      "MZN": {
        "code": "MZN",
        "symbol": "MT",
        "name": "Mozambican metical",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "",
        "name": "Mozambican centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "NAD": {
    "code": "NAD",
    "precision": 5,
    "units": {
      "NAD": {
        "code": "NAD",
        "symbol": "$",
        "name": "Namibian dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "c",
        "name": "Namibian cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "NGN": {
    "code": "NGN",
    "precision": 5,
    "units": {
      "NGN": {
        "code": "NGN",
        "symbol": "₦",
        "name": "Nigerian Naira",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Kobo",
        "symbol": "",
        "name": "Nigerian Kobo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "NIO": {
    "code": "NIO",
    "precision": 5,
    "units": {
      "NIO": {
        "code": "NIO",
        "symbol": "C$",
        "name": "Nicaraguan córdoba",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centavo",
        "symbol": "",
        "name": "Nicaraguan centavo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "NOK": {
    "code": "NOK",
    "precision": 5,
    "units": {
      "NOK": {
        "code": "NOK",
        "symbol": "kr",
        "name": "Norwegian Krone",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "øre",
        "symbol": "",
        "name": "Norwegian øre",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "NPR": {
    "code": "NPR",
    "precision": 5,
    "units": {
      "NPR": {
        "code": "NPR",
        "symbol": "Rs",
        "name": "Nepalese Rupee",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Paisa",
        "symbol": "",
        "name": "Nepalese Paisa",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "NZD": {
    "code": "NZD",
    "precision": 5,
    "units": {
      "NZD": {
        "code": "NZD",
        "symbol": "$",
        "name": "New Zealand dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "c",
        "name": "New Zealand cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "OMR": {
    "code": "OMR",
    "precision": 5,
    "units": {
      "OMR": {
        "code": "OMR",
        "symbol": "ع.ر.",
        "name": "Omani rial",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "baisa",
        "symbol": "bz",
        "name": "Omani baisa",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "PAB": {
    "code": "PAB",
    "precision": 5,
    "units": {
      "PAB": {
        "code": "PAB",
        "symbol": "B/",
        "name": "Balboa balboa",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Centésimo",
        "symbol": "",
        "name": "Balboa Centésimo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "PEN": {
    "code": "PEN",
    "precision": 5,
    "units": {
      "PEN": {
        "code": "PEN",
        "symbol": "S/",
        "name": "Peruvian nuevo nuevo sol",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "céntimo",
        "symbol": "",
        "name": "Peruvian nuevo céntimo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "PGK": {
    "code": "PGK",
    "precision": 5,
    "units": {
      "PGK": {
        "code": "PGK",
        "symbol": "K",
        "name": "Papua New Guinean Kina",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Toea",
        "symbol": "",
        "name": "Papua New Guinean Toea",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "PHP": {
    "code": "PHP",
    "precision": 5,
    "units": {
      "PHP": {
        "code": "PHP",
        "symbol": "₱",
        "name": "Philippine Peso",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Sentimo",
        "symbol": "",
        "name": "Philippine Sentimo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "PKR": {
    "code": "PKR",
    "precision": 5,
    "units": {
      "PKR": {
        "code": "PKR",
        "symbol": "Rs",
        "name": "Pakistani Rupee",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Paisa",
        "symbol": "",
        "name": "Pakistani Paisa",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "PLN": {
    "code": "PLN",
    "precision": 5,
    "units": {
      "PLN": {
        "code": "PLN",
        "symbol": "zł",
        "name": "Polish złoty",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Grosz",
        "symbol": "gr",
        "name": "Polish Grosz",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "PYG": {
    "code": "PYG",
    "precision": 5,
    "units": {
      "PYG": {
        "code": "PYG",
        "symbol": "₲",
        "name": "Paraguayan guarani",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "céntimo",
        "symbol": "",
        "name": "Paraguayan céntimo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "QAR": {
    "code": "QAR",
    "precision": 5,
    "units": {
      "QAR": {
        "code": "QAR",
        "symbol": "ق.ر ",
        "name": "Qatari riyal",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "dirham",
        "symbol": "",
        "name": "Qatari dirham",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "RON": {
    "code": "RON",
    "precision": 5,
    "units": {
      "RON": {
        "code": "RON",
        "symbol": "lei",
        "name": "Romanian leu",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "bani",
        "symbol": "",
        "name": "Romanian bani",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "RSD": {
    "code": "RSD",
    "precision": 5,
    "units": {
      "RSD": {
        "code": "RSD",
        "symbol": "РСД",
        "name": "Serbian dinar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "para",
        "symbol": "",
        "name": "Serbian para",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "RUB": {
    "code": "RUB",
    "precision": 5,
    "units": {
      "RUB": {
        "code": "RUB",
        "symbol": "₽",
        "name": "Russian rouble",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "kopeyka",
        "symbol": "к",
        "name": "Russian kopeyka",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "RWF": {
    "code": "RWF",
    "precision": 5,
    "units": {
      "RWF": {
        "code": "RWF",
        "symbol": "RWF",
        "name": "Rwandan franc",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centime",
        "symbol": "",
        "name": "Rwandan centime",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SAR": {
    "code": "SAR",
    "precision": 5,
    "units": {
      "SAR": {
        "code": "SAR",
        "symbol": "ر.س",
        "name": "Saudi Arabian riyal",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Halala",
        "symbol": "",
        "name": "Saudi Arabian Halala",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SBD": {
    "code": "SBD",
    "precision": 5,
    "units": {
      "SBD": {
        "code": "SBD",
        "symbol": "SI$",
        "name": "Solomon Islander dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Solomon Islander cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SCR": {
    "code": "SCR",
    "precision": 5,
    "units": {
      "SCR": {
        "code": "SCR",
        "symbol": "Rs",
        "name": "Seychellois rupee",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Seychellois cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SDG": {
    "code": "SDG",
    "precision": 5,
    "units": {
      "SDG": {
        "code": "SDG",
        "symbol": "",
        "name": "Sudanese pound",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "piastres",
        "symbol": ".‏س.ج",
        "name": "Sudanese piastres",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SEK": {
    "code": "SEK",
    "precision": 5,
    "units": {
      "SEK": {
        "code": "SEK",
        "symbol": "kr",
        "name": "Swedish krona",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "ören",
        "symbol": "",
        "name": "Swedish ören",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SGD": {
    "code": "SGD",
    "precision": 5,
    "units": {
      "SGD": {
        "code": "SGD",
        "symbol": "$",
        "name": "Singapore dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "S¢",
        "name": "Singapore cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SLL": {
    "code": "SLL",
    "precision": 5,
    "units": {
      "SLL": {
        "code": "SLL",
        "symbol": "Le",
        "name": "Sierra Leonean Leone",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "c",
        "name": "Sierra Leonean cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SOS": {
    "code": "SOS",
    "precision": 5,
    "units": {
      "SOS": {
        "code": "SOS",
        "symbol": "S",
        "name": "Somali shilling",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "senti",
        "symbol": "",
        "name": "Somali senti",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SRD": {
    "code": "SRD",
    "precision": 5,
    "units": {
      "SRD": {
        "code": "SRD",
        "symbol": "$",
        "name": "Surinamese dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Surinamese cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SSP": {
    "code": "SSP",
    "precision": 5,
    "units": {
      "SSP": {
        "code": "SSP",
        "symbol": "£",
        "name": "South Sudanese pound",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "piaster",
        "symbol": "",
        "name": "South Sudanese piaster",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SYP": {
    "code": "SYP",
    "precision": 5,
    "units": {
      "SYP": {
        "code": "SYP",
        "symbol": "£",
        "name": "Syrian pound",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "piastre",
        "symbol": "",
        "name": "Syrian piastre",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SZL": {
    "code": "SZL",
    "precision": 5,
    "units": {
      "SZL": {
        "code": "SZL",
        "symbol": "L or E",
        "name": "Swazi Lilangeni or emalangeni",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Swazi cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "THB": {
    "code": "THB",
    "precision": 5,
    "units": {
      "THB": {
        "code": "THB",
        "symbol": "฿",
        "name": "Thai baht",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "satang",
        "symbol": "",
        "name": "Thai satang",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "TJS": {
    "code": "TJS",
    "precision": 5,
    "units": {
      "TJS": {
        "code": "TJS",
        "symbol": "TJS",
        "name": "Tajikistani somoni",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "diram",
        "symbol": "",
        "name": "Tajikistani diram",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "TMT": {
    "code": "TMT",
    "precision": 5,
    "units": {
      "TMT": {
        "code": "TMT",
        "symbol": "T",
        "name": "Turkmenistan manat",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "tenge",
        "symbol": "",
        "name": "Turkmenistan tenge",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "TND": {
    "code": "TND",
    "precision": 5,
    "units": {
      "TND": {
        "code": "TND",
        "symbol": "DT",
        "name": "Tunisian dinar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "milim or millime",
        "symbol": "ت.د",
        "name": "Tunisian milim or millime",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "TOP": {
    "code": "TOP",
    "precision": 5,
    "units": {
      "TOP": {
        "code": "TOP",
        "symbol": "T$",
        "name": "Tongan hau",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "seniti",
        "symbol": "¢",
        "name": "Tongan seniti",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "TRY": {
    "code": "TRY",
    "precision": 5,
    "units": {
      "TRY": {
        "code": "TRY",
        "symbol": "₺",
        "name": "Turkish lira",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "kuruş",
        "symbol": "Kr",
        "name": "Turkish kuruş",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "TTD": {
    "code": "TTD",
    "precision": 5,
    "units": {
      "TTD": {
        "code": "TTD",
        "symbol": "TT$",
        "name": "Trinidadian dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Trinidadian cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "TWD": {
    "code": "TWD",
    "precision": 5,
    "units": {
      "TWD": {
        "code": "TWD",
        "symbol": "NT$",
        "name": "Taiwan New dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "jiao",
        "symbol": "角",
        "name": "Taiwan New jiao",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "TZS": {
    "code": "TZS",
    "precision": 5,
    "units": {
      "TZS": {
        "code": "TZS",
        "symbol": "Sh",
        "name": "Tanzanian Shilling",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Tanzanian cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "UAH": {
    "code": "UAH",
    "precision": 5,
    "units": {
      "UAH": {
        "code": "UAH",
        "symbol": "₴",
        "name": "Ukrainian Hryvnia",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Kopiyka",
        "symbol": "",
        "name": "Ukrainian Kopiyka",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "UGX": {
    "code": "UGX",
    "precision": 5,
    "units": {
      "UGX": {
        "code": "UGX",
        "symbol": "USh",
        "name": "Ugandan Shilling",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Ugandan cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "USD": {
    "code": "USD",
    "precision": 5,
    "units": {
      "USD": {
        "code": "USD",
        "symbol": "$",
        "name": "US dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "¢",
        "name": "US cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "UYU": {
    "code": "UYU",
    "precision": 5,
    "units": {
      "UYU": {
        "code": "UYU",
        "symbol": "$U",
        "name": "Uruguayan peso",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centésimo",
        "symbol": "¢",
        "name": "Uruguayan centésimo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "UZS": {
    "code": "UZS",
    "precision": 5,
    "units": {
      "UZS": {
        "code": "UZS",
        "symbol": "UZS",
        "name": "Uzbekistani som",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Tiyin",
        "symbol": "",
        "name": "Uzbekistani Tiyin",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "VES": {
    "code": "VES",
    "precision": 5,
    "units": {
      "VES": {
        "code": "VES",
        "symbol": "Bs",
        "name": "Venezuelan bolívares soberano",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "céntimo",
        "symbol": "¢",
        "name": "Venezuelan céntimo",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "VND": {
    "code": "VND",
    "precision": 5,
    "units": {
      "VND": {
        "code": "VND",
        "symbol": "₫",
        "name": "Vietnamese dong",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "kVND": {
        "code": "kVND",
        "symbol": "k₫",
        "name": "Vietnamese kilo-dong",
        "shift": -3,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "Hào",
        "symbol": "",
        "name": "Vietnamese Hào",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "VUV": {
    "code": "VUV",
    "precision": 5,
    "units": {
      "VUV": {
        "code": "VUV",
        "symbol": "VT",
        "name": "Ni-Vanuatu vatu",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "",
        "symbol": "",
        "name": "Ni-Vanuatu ",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "WST": {
    "code": "WST",
    "precision": 5,
    "units": {
      "WST": {
        "code": "WST",
        "symbol": "$",
        "name": "Samoan tālā",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "sene",
        "symbol": "",
        "name": "Samoan sene",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "XCD": {
    "code": "XCD",
    "precision": 5,
    "units": {
      "XCD": {
        "code": "XCD",
        "symbol": "EC$",
        "name": "East Caribbean dollar",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "East Caribbean cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "XOF": {
    "code": "XOF",
    "precision": 5,
    "units": {
      "XOF": {
        "code": "XOF",
        "symbol": "",
        "name": "CFA franc",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centime",
        "symbol": "",
        "name": "CFA centime",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "XPF": {
    "code": "XPF",
    "precision": 5,
    "units": {
      "XPF": {
        "code": "XPF",
        "symbol": "",
        "name": "CFP franc",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "centime",
        "symbol": "",
        "name": "CFP centime",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "YER": {
    "code": "YER",
    "precision": 5,
    "units": {
      "YER": {
        "code": "YER",
        "symbol": "",
        "name": "Yemeni rial",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "fils",
        "symbol": "",
        "name": "Yemeni fils",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "ZAR": {
    "code": "ZAR",
    "precision": 5,
    "units": {
      "ZAR": {
        "code": "ZAR",
        "symbol": "R",
        "name": "South African Rand",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "c",
        "name": "South African cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "ZMW": {
    "code": "ZMW",
    "precision": 5,
    "units": {
      "ZMW": {
        "code": "ZMW",
        "symbol": "ZMK",
        "name": "Zambian Kwacha",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "ngwee",
        "symbol": "",
        "name": "Zambian ngwee",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "ZWD": {
    "code": "ZWD",
    "precision": 5,
    "units": {
      "ZWD": {
        "code": "ZWD",
        "symbol": "Z$",
        "name": "Zimbabwean dolalr",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "Z$¢",
        "name": "Zimbabwean cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "XXX": {
    "code": "XXX",
    "precision": 5,
    "units": {
      "XXX": {
        "code": "XXX",
        "symbol": "",
        "name": "Play",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "X5T": {
    "code": "X5T",
    "precision": 5,
    "units": {
      "X5T": {
        "code": "X5T",
        "symbol": "",
        "name": "Points",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "",
        "name": "Point cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "USDT": {
    "code": "USDT",
    "precision": 5,
    "units": {
      "USDT": {
        "code": "USDT",
        "symbol": "₮",
        "name": "Tether",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "₮¢",
        "name": "Tether cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "USD1": {
    "code": "USD1",
    "precision": 5,
    "units": {
      "USD1": {
        "code": "USD1",
        "symbol": "USD1 $",
        "name": "World Liberty Financial USD",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "USD1 ¢",
        "name": "World Liberty Financial cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "BUSD": {
    "code": "BUSD",
    "precision": 5,
    "units": {
      "BUSD": {
        "code": "BUSD",
        "symbol": "BUSD",
        "name": "Binance USD",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "BUSD¢",
        "name": "Binance USD cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SOL": {
    "code": "SOL",
    "precision": 9,
    "units": {
      "SOL": {
        "code": "SOL",
        "symbol": "SOL",
        "name": "SOL",
        "shift": 0,
        "displayPrecision": 9,
        "inputPrecision": 9
      },
      "mSOL": {
        "code": "mSOL",
        "symbol": "mSOL",
        "name": "milli-Solana",
        "shift": 3,
        "displayPrecision": 6,
        "inputPrecision": 6
      }
    }
  },
  "USDC": {
    "code": "USDC",
    "precision": 5,
    "units": {
      "USDC": {
        "code": "USDC",
        "symbol": "USDC",
        "name": "USDC",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "BAMBOO": {
    "code": "BAMBOO",
    "precision": 5,
    "units": {
      "USDC": {
        "code": "BAMBOO",
        "symbol": "",
        "name": "BAMBOO",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "DAI": {
    "code": "DAI",
    "precision": 5,
    "units": {
      "DAI": {
        "code": "DAI",
        "symbol": "DAI",
        "name": "DAI",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "HI": {
    "code": "HI",
    "precision": 8,
    "units": {
      "HI": {
        "code": "HI",
        "symbol": "HI",
        "name": " HI Token",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      },
      "cent": {
        "code": "cent",
        "symbol": "c",
        "name": " cent",
        "shift": 2,
        "displayPrecision": 0,
        "inputPrecision": 0
      }
    }
  },
  "SHIB": {
    "code": "SHIB",
    "precision": 8,
    "units": {
      "SHIB": {
        "code": "SHIB",
        "symbol": "SHIB",
        "name": "Shiba Inu",
        "displayPrecision": 8,
        "inputPrecision": 8,
        "shift": 0
      }
    }
  },
  "PYUSD": {
    "code": "PYUSD",
    "precision": 6,
    "units": {
      "PYUSD": {
        "code": "PYUSD",
        "symbol": "PYUSD",
        "name": "PayPal USD",
        "displayPrecision": 2,
        "inputPrecision": 6,
        "shift": 0
      }
    }
  },
  "BCT": {
    "code": "BCT",
    "precision": 18,
    "units": {
      "BCT": {
        "code": "BCT",
        "symbol": "BCT",
        "name": "Bitcasino Token",
        "displayPrecision": 18,
        "inputPrecision": 18,
        "shift": 0
      }
    }
  },
  "BGC": {
    "code": "BGC",
    "precision": 5,
    "units": {
      "BGC": {
        "code": "BGC",
        "symbol": "",
        "name": "Bahrain Gold Coin",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "GLD": {
    "code": "GLD",
    "precision": 5,
    "units": {
      "GLD": {
        "code": "GLD",
        "symbol": "GC",
        "name": "GoldCoin",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "SS1": {
    "code": "SS1",
    "precision": 5,
    "units": {
      "SS1": {
        "code": "SS1",
        "symbol": "SC",
        "name": "SweepCoin",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "BC1": {
    "code": "BC1",
    "precision": 5,
    "units": {
      "BC1": {
        "code": "BC1",
        "symbol": "BC",
        "name": "BlitzCoin",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "PGSC": {
    "code": "PGSC",
    "precision": 5,
    "units": {
      "PGSC": {
        "code": "PGSC",
        "symbol": "SC",
        "name": "Sweepstake Coin",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "PGGC": {
    "code": "PGGC",
    "precision": 5,
    "units": {
      "PGGC": {
        "code": "PGGC",
        "symbol": "GC",
        "name": "Gold Coin",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "EEGP": {
    "code": "EEGP",
    "precision": 5,
    "units": {
      "EEGP": {
        "code": "EEGP",
        "symbol": "RC",
        "name": "Rainbet Cash",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "EPGP": {
    "code": "EPGP",
    "precision": 5,
    "units": {
      "EPGP": {
        "code": "EPGP",
        "symbol": "GC",
        "name": "Gold Coin",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "CAPY": {
    "code": "CAPY",
    "precision": 5,
    "units": {
      "CAPY": {
        "code": "CAPY",
        "symbol": "CC",
        "name": "Sweep Coin",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "CAOC": {
    "code": "CAOC",
    "precision": 5,
    "units": {
      "CAOC": {
        "code": "CAOC",
        "symbol": "OC",
        "name": "Gold Coin",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "DLS": {
    "code": "DLS",
    "precision": 5,
    "units": {
      "DLS": {
        "code": "DLS",
        "symbol": "DLS",
        "name": "Diamond Locks",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "CVD": {
    "code": "CVD",
    "precision": 5,
    "units": {
      "CVD": {
        "code": "CVD",
        "symbol": "CC",
        "name": "Coverd Cash",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "WOW": {
    "code": "WOW",
    "precision": 5,
    "units": {
      "WOW": {
        "code": "WOW",
        "symbol": "WOW",
        "name": "WowCoin",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "GC": {
    "code": "GC",
    "precision": 5,
    "units": {
      "GC": {
        "code": "GC",
        "symbol": "GC",
        "name": "GoldCoin",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "UFC": {
    "code": "UFC",
    "precision": 5,
    "units": {
      "UFC": {
        "code": "UFC",
        "symbol": "",
        "remarks": "Symbol should be empty on client's request!",
        "name": "UltimateFunCoin",
        "shift": 0,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "kIDR": {
    "code": "kIDR",
    "precision": 5,
    "units": {
      "kIDR": {
        "code": "kIDR",
        "symbol": "kRp",
        "name": "Indonesian kilo-rupiah",
        "shift": -3,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "kVND": {
    "code": "kVND",
    "precision": 5,
    "units": {
      "kVND": {
        "code": "kVND",
        "symbol": "k₫",
        "name": "Vietnamese kilo-dong",
        "shift": -3,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  },
  "mBTC": {
    "code": "mBTC",
    "precision": 8,
    "units": {
      "mBTC": {
        "code": "mBTC",
        "symbol": "m₿",
        "name": "Milli-bitcoin",
        "displayPrecision": 4,
        "inputPrecision": 5,
        "shift": 3
      }
    }
  },
  "mETH": {
    "code": "mETH",
    "precision": 8,
    "units": {
      "mETH": {
        "code": "mETH",
        "symbol": "mETH",
        "name": "Milliether",
        "displayPrecision": 4,
        "inputPrecision": 5,
        "shift": 3
      }
    }
  },
  "mLTC": {
    "code": "mLTC",
    "precision": 8,
    "units": {
      "mLTC": {
        "code": "mLTC",
        "symbol": "mŁ",
        "name": "milli-Litecoin",
        "displayPrecision": 4,
        "inputPrecision": 5,
        "shift": 3
      }
    }
  },
  "mXRP": {
    "code": "mXRP",
    "precision": 6,
    "units": {
      "mXRP": {
        "code": "mXRP",
        "symbol": "mXRP",
        "name": "milli-Ripple",
        "displayPrecision": 3,
        "inputPrecision": 3,
        "shift": 3
      }
    }
  },
  "mTRX": {
    "code": "mTRX",
    "precision": 8,
    "units": {
      "mTRX": {
        "code": "mTRX",
        "symbol": "mTRX",
        "name": "milli-Tron",
        "displayPrecision": 4,
        "inputPrecision": 3,
        "shift": 3
      }
    }
  },
  "mDOGE": {
    "code": "mDOGE",
    "precision": 6,
    "units": {
      "mDOGE": {
        "code": "mDOGE",
        "symbol": "mƉ",
        "name": "milli-Doge",
        "displayPrecision": 3,
        "inputPrecision": 3,
        "shift": 3
      }
    }
  },
  "mADA": {
    "code": "mADA",
    "precision": 6,
    "units": {
      "mADA": {
        "code": "mADA",
        "symbol": "mADA",
        "name": "milli-Cardano",
        "displayPrecision": 3,
        "inputPrecision": 3,
        "shift": 3
      }
    }
  },
  "mSOL": {
    "code": "mSOL",
    "precision": 9,
    "units": {
      "mSOL": {
        "code": "mSOL",
        "symbol": "mSOL",
        "name": "milli-Solana",
        "shift": 3,
        "displayPrecision": 6,
        "inputPrecision": 6
      }
    }
  },
  "mBNB": {
    "code": "mBNB",
    "precision": 8,
    "units": {
      "mBNB": {
        "code": "mBNB",
        "symbol": "mBNB",
        "name": "Millibnb",
        "displayPrecision": 4,
        "inputPrecision": 5,
        "shift": 3
      }
    }
  },
  "mTON": {
    "code": "mTON",
    "precision": 9,
    "units": {
      "mTON": {
        "code": "mTON",
        "symbol": "mTON",
        "name": "milli-Toncoin",
        "shift": 3,
        "displayPrecision": 6,
        "inputPrecision": 6
      }
    }
  },
  "sat": {
    "code": "sat",
    "precision": 8,
    "units": {
      "sat": {
        "code": "sat",
        "symbol": "₿",
        "name": "Satoshi",
        "displayPrecision": 0,
        "inputPrecision": 0,
        "shift": 8
      }
    }
  },
  "Gwei": {
    "code": "Gwei",
    "precision": 8,
    "units": {
      "Gwei": {
        "code": "Gwei",
        "symbol": "Gwei",
        "name": "Gwei",
        "displayPrecision": 0,
        "inputPrecision": 0,
        "shift": 8
      }
    }
  },
  "kINR": {
    "code": "kINR",
    "precision": 5,
    "units": {
      "kINR": {
        "code": "kINR",
        "symbol": "k₹",
        "name": "Indian kilo-rupee",
        "shift": -3,
        "displayPrecision": 2,
        "inputPrecision": 4
      }
    }
  }
}
